import {
    Table,
    Button,
    notification,
    Pagination,
    Select,
    Input,
    Tooltip,
} from "antd";
import React, { useState, useEffect, useRef } from "react";
import ModalComponent from "../Modal/UserTableModal";
import { getRequest } from "../../util/APIUtils";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const PAGE_SIZES = [5, 10, 20, 50, 100];

const UserTable = () => {
    const [dataSource, setDataSource] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [totalDataCount, setTotalDataCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
    const [goToPage, setGoToPage] = useState("");
    const [tcknSearchText, setTCKNSearchText] = useState("");
    const [predicate,setPredicate] = useState("&tckn=" + tcknSearchText);
    const [tcknSearchedColumn, setTCKNSearchedColumn] = useState("");




    const searchInputRef = useRef();

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (tcknSearchedColumn === "tckn") {
            setPredicate("&tckn=" + tcknSearchText);
        }
        fetchData();
    }, [currentPage, pageSize, tcknSearchText]);

    const updatesUserRecord = (updatedItem) => {
        console.log("data1::",updatedItem)
        const updatedDataSource = dataSource.map((item) => {
            if (item.fuelCampaignFormId === updatedItem.fuelCampaignFormId) {
                return updatedItem;
            }
            return item;
        });
        console.log("data2::",updatedItem)
        setDataSource(updatedDataSource);

        if(updatedItem && updatedItem.fuelCampaignFormId == undefined){
            updatedItem.fuelCampaignFormId=-1
        }

        return fetch(`/updateFuelsCampaign/${updatedItem.fuelCampaignFormId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedItem),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Kullanıcı güncellenirken bir hata oluştu.");
                }
                notification.success({
                    message: "Başarılı",
                    description: "Kullanıcı başarıyla güncellendi.",
                });

                return response.json();
            })
            .then(() => {
                fetchData();
            })
            .catch((error) => {
                console.error("Güncelleme hatası:", error);
            });
    };

    const createUserRecord = (addItem) => {
        return fetch('/addPetrolOfisi', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(addItem),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Başvuru oluşturulurken bir hata oluştu.');
                }
                notification.success({
                    message: 'Başarılı',
                    description: 'Başvuru başarıyla oluşturuldu.',
                });
                return response.json();
            })
            .then(() => {
                fetchData();
            })
            .catch((error) => {
                console.error('Oluşturma hatası:', error);
            });
    };

    const fetchData = () => {
        const tcknPredicate = tcknSearchText ? "&tckn=" + tcknSearchText : "";
        getRequest("/form/getAllFuelsCampaign?page=" + (currentPage - 1) + "&size=" + pageSize + tcknPredicate)
            .then((response) => {
                setTotalDataCount(response.data.totalElements);
                setDataSource(response.data.content);
            })
            .catch((error) => {
                console.error("Veri çekme hatası:", error);
            });
    };


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setTCKNSearchText(selectedKeys[0]);
        setTCKNSearchedColumn(dataIndex);
        setCurrentPage(1);

    };


    const handleReset = (clearFilters) => {
        clearFilters();
        setTCKNSearchText("");
        setTCKNSearchedColumn("");
        setCurrentPage(1);
        fetchData();
    };


    const getColumnSearchProps = (dataIndex, searchText, setSearchText, searchedColumn, setSearchedColumn) => ({
        filterDropdown: ({
                             setSelectedKeys,
                             selectedKeys,
                             confirm,
                             clearFilters,
                         }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInputRef}
                    placeholder={`Ara ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, setSearchText, setSearchedColumn)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex, setSearchText, setSearchedColumn)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Ara
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters, setSearchText, setSearchedColumn)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Sıfırla
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInputRef.current.select(), 100);
            }
        },
        render: (text) =>
            tcknSearchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[tcknSearchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });

    const showModal = (item = {}) => {
        setSelectedItem(item);
        setModalVisible(true);
    };

    const handleCreate = () => {
        setSelectedItem();
        setModalVisible(true);
    };

    const handleOk = () => {
        setModalVisible(false);

    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const handleGoToPageChange = (event) => {
        const { value } = event.target;
        if (/^\d*$/.test(value)) {
            setGoToPage(value);
        }
    };

    const handleGoToPageEnter = (event) => {
        if (event.key === "Enter") {
            const pageNumber = parseInt(goToPage);
            if (
                !isNaN(pageNumber) &&
                pageNumber >= 1 &&
                pageNumber <= Math.ceil(totalDataCount / pageSize)
            ) {
                setCurrentPage(pageNumber);
            }
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setCurrentPage(1);
    };

    const columns = [
        {
            title: "İsim-Soyisim",
            dataIndex: "nameSurname",
            key: "nameSurname",
        },
        {
            title: "E-mail",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Telefon Numarası",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            render: (phoneNumber) => {
                const formattedPhoneNumber = `+90 (${phoneNumber.slice(
                    0,
                    3
                )}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
                return <span>{formattedPhoneNumber}</span>;
            },
        },
        {
            title: "TCKN",
            dataIndex: "tckn",
            key: "tckn",
            width: "10%",
            sorter: true,
            ...getColumnSearchProps("tckn", "TCKN ile ara."),
            render: (text) =>
                tcknSearchedColumn === "tckn" ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                        searchWords={[tcknSearchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ""}
                    />
                ) : (
                    text
                ),
        },
        {
            title: "Vergi Dairesi",
            dataIndex: "taxAdministration",
            key: "taxAdministration",
        },
        {
            title: "Şehir",
            dataIndex: "city",
            key: "city",
        },
        {
            title: "İlçe",
            dataIndex: "" +
                "",
            key: "county",
        },
        {
            title: "Eczane Adı",
            dataIndex: "pharmacy",
            key: "pharmacy",
        },
        {
            title: "Adres",
            dataIndex: "address",
            key: "address",
        },
        {
            title: "Filo Numarası",
            dataIndex: "fleetNumber",
            key: "fleetNumber",
        },
        {
            title: "",
            dataIndex: "order",
            width: "5%",
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <a onClick={() => showModal(record)}>Düzenle</a>
                ) : null,
        },
    ];

    return (
        <div className="page">

            <div className="top">
                <Tooltip placement="top" title="Yeni Basvuru">
                    <Button
                        onClick={() => showModal({})}
                        type="primary"
                        shape="circle" icon={<PlusOutlined/>}
                        size="large"/>
                </Tooltip>
            </div>

            <b>Yakıt Başvuruları </b>

            <div className="tableAll">
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                />
            </div>

            <div className="footer">
                <div className="toplam">Toplam {totalDataCount} Kayıt</div>

                <div className="pagination-container">
                    <Pagination
                        current={currentPage}
                        total={totalDataCount}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                    />
                </div>

                <div className="sayfa">
                    <Select value={pageSize} onChange={handlePageSizeChange}>
                        {PAGE_SIZES.map((size) => (
                            <Select.Option key={size} value={size}>
                                {size} /{" "}
                                <span style={{ minWidth: "3ch", display: "inline-block" }}>
                  sayfa
                </span>
                            </Select.Option>
                        ))}
                    </Select>
                </div>

                <div className="git">
                    <label style={{ minWidth: "3ch" }}>Git </label>
                    <Input
                        style={{ width: "7ch", height: "31px" }}
                        value={goToPage}
                        onChange={handleGoToPageChange}
                        onKeyPress={handleGoToPageEnter}
                    />
                    <span style={{ display: "inline-block", minWidth: "5ch" }}>
            {" "}
                        Sayfa
          </span>
                </div>
            </div>

            <ModalComponent
                visible={modalVisible}
                onClose={handleCancel}
                selectedItem={selectedItem}
                onUpdate={updatesUserRecord}
                onCreate={createUserRecord}
            />
        </div>
    );
};

export default UserTable;


// WEBPACK FOOTER //
// ./src/component/Table/UserTable.js